// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"9cceed64","291":"f3a9ff63","832":"6fd9370b"}[chunkId] + ".chunk.js";
};